import editorLayoutList from '../../../config/richTextConfig/questionLayout';
import styleVars from '../rich-text-vars.scss';

const editorMaxWidth = parseInt(styleVars.editorMaxWidth, 10);
const centeredEditorMaxWidth = parseInt(styleVars.centeredEditorMaxWidth, 10);

export const getMaxWidth = layout =>
  layout === editorLayoutList.centered
    ? centeredEditorMaxWidth
    : editorMaxWidth;
